import { render, staticRenderFns } from "./SearchVendorsView.vue?vue&type=template&id=4b0d875e&scoped=true&"
import script from "./SearchVendorsView.vue?vue&type=script&lang=js&"
export * from "./SearchVendorsView.vue?vue&type=script&lang=js&"
import style0 from "./SearchVendorsView.vue?vue&type=style&index=0&id=4b0d875e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d875e",
  null
  
)

export default component.exports